
import * as React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl';
import { Link } from 'gatsby'
import { FrontPageCard } from 'components/shared/cards/FrontPageCard';
import { useDraggableContainer } from 'hooks/useDraggableContainer'
import { useFadeVisibility } from 'hooks/useFadeVisibility';
import isBrowser from 'services/isBrowser';
import { RegionBase } from 'templates/fragments/region';
import { getActiveMonth, getMonthIndexFromName, useSelectedMonthContext } from 'context/SelectedMonthContext';
import ensureMonthIndexInRange from 'services/ensureMonthIndexInRange';
import getLocationPath from 'services/getLocationPath';

export const DestinationRecommendationCards = ({ title, locationsToShow, month=null, useSlugNames,lazyLoad }: { title: string, locationsToShow: RegionBase[], month?: string, useSlugNames?: boolean, lazyLoad?: boolean }) => {
    const intl = useIntl()
    // if month is not provided, use the one from context
    if (month == null) {
        const [months, dispatch] = useSelectedMonthContext();
        month = getActiveMonth(months).name;
    }

    
    const innerItemsWidth = locationsToShow.length * 370
    const [itemsWidthWiderThanWindow, setItemsWidthWiderThanWindow] = React.useState(innerItemsWidth > ((!(typeof window !== 'undefined')) ? 0 : window.innerWidth))
    const destinationScrollRef = React.useRef(null)

    const { mouseDownHandler, mouseUpHandler } = useDraggableContainer(destinationScrollRef, itemsWidthWiderThanWindow)
    const { fadeVisible, mouseReleaseHandler } = useFadeVisibility(destinationScrollRef, mouseUpHandler)

    React.useEffect(() => {
        if (!isBrowser()) return;
        window.addEventListener('resize', () => setItemsWidthWiderThanWindow(innerItemsWidth > window.innerWidth))
        return () => window.removeEventListener('resize', () => setItemsWidthWiderThanWindow(innerItemsWidth > window.innerWidth))
    })
    const monthIndex = getMonthIndexFromName(month);
    let indexes = [monthIndex - 1, monthIndex + 1, monthIndex + 2];
    indexes = indexes.map(idx => ensureMonthIndexInRange(idx));
    const [lastMonth, nextMonth, nextPlusMonth] = indexes;


    return (<>
        <div className="height--1" />
        <h2 className="text--center destination__info__header margin--auto">{title}</h2>
        <div className="height--1" />
        <div className="fp__destinations__wrapper">
            <div className="row">
                {locationsToShow.map((destination) => destination.mainImg && <div key={destination.name} className="center fp__card">
                    <FrontPageCard imageDataLike={destination.mainImg.childImageSharp.gatsbyImageData}
                        partOfTheWorld={intl.formatMessage({ id: `common.continents.${destination.country.continent}` })}
                        tags={destination.tags}
                        location={useSlugNames ? (destination.slugName || destination.name) : destination.name}
                        weatherData={destination.weatherData}
                        lazyLoad={lazyLoad}
                        slug={getLocationPath({ location: destination, isCountryInstance: false, monthIndex })}
                    />
                </div>)}
            </div>
        </div>
    </>)

}

